<template>
  <cta-row white-bg align-start overlay-modal>
    <div :class="[classes, 'action-panel__footer']">
      <slot />
    </div>
  </cta-row>
</template>

<script>
import CtaRow from "@/components/CtaRow"

export default {
  components: {
    CtaRow
  },

  props: {
    classes: { type: String, default: "" }
  }
}
</script>
